/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentRestrictionNotSetPasswordParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('not-set')],
]);
export class AssignmentRestrictionNotSetPassword extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentRestrictionNotSetPasswordParser.decode(input).map(res => new AssignmentRestrictionNotSetPassword(res));
    }
    static unsafeDecode(input) {
        return AssignmentRestrictionNotSetPassword.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentRestrictionNotSetPasswordParser.encode(data);
    }
    static schema() {
        return AssignmentRestrictionNotSetPasswordParser.schema();
    }
}
